// IS THIS SERVER STRING FIT TO SHOW A PERSON? (Session AGV)
//
// ApiError.code carries THREE different kinds of value, and only one of them is prose. apiRequest
// (lib/api.ts) builds it as:
//
//     let code = res.statusText;                 // "Unauthorized", "Not Found", "Bad Request"
//     if (body?.message) code = body.message;    // "Choose an engineer."      <- the only prose
//     else if (body?.error) code = body.error;   // "forbidden", "not_found"   <- a machine slug
//
// So "show the server's own words instead of a generic line" is right only when the server actually
// sent words. Session AGV started surfacing ApiError.code on three surfaces, and without this a
// refusal could put the literal string "forbidden" or "Unauthorized" in front of an engineer --
// worse than the generic line it replaced, because it reads as a glitch rather than an explanation.
//
// THE RULE: prose has a space AND ends the way a sentence ends. That excludes every machine slug
// (no space, no terminator) and every HTTP status text ("Not Found", "Internal Server Error" --
// spaces, but no terminator), while admitting this platform's server messages, which are written as
// sentences and end in a full stop throughout ("Choose an engineer.", "That person could not be
// found.", "This account has no engineer profile, so it has no timesheet of its own.").
//
// It is deliberately conservative in the safe direction: a server message that forgot its full stop
// is merely not shown, and the caller falls back to its own plain-English line. Nothing breaks, and
// no raw token ever reaches a person.
export function presentableServerMessage(raw: string | null | undefined): string | null {
  const s = raw?.trim();
  if (!s) return null;
  if (!s.includes(" ")) return null;
  return /[.!?]$/.test(s) ? s : null;
}
